<div class="footer" fxLayout="row">
	<div fxFlex="auto" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center" vexContainer>
		<ng-container *ngFor="let menuitem of mobileMenu$ | async">
			<div fxLayout="column" fxLayoutAlign="center center" (click)="activateMenu(menuitem)">
				<mat-icon>{{ menuitem.iconName }}</mat-icon>
				<span class="text">{{ menuitem.label | translate }}</span>
			</div>
		</ng-container>
	</div>
</div>
